import React, {useEffect, useState} from "react";
import {DELETED_MARKETS_KEY, ExchangesRefLinksObj, FAVORITES_MARKETS_KEY, getExchangeSpotLink} from "../../constants";
import {
    setDeleted,
    setFavorites,
    setSelectedItem,
    setSelectedItemIndex, setSelectedPrecisions,
} from "../../redux/actions";
import {IFavoriteDeleteItem, ISelectedPrecisions, ITOHistory} from "../../types";
import {imageLink, imageLinkToEx, normalizeTime, numToShortText, openInNewTab} from "../../utils";
import {
    ArrowWrapper, CenterCenterContainer, DetailsBottom, DetailsCenter, DetailsContainer, DetailsExchange,
    DetailsExchangeContainer,
    DetailsExchangeIcon, DetailsExchangeName, DetailsMarketIcon, DetailsMarketWrapper, DetailsPrice,
    DetailsPriceContainer, DetailsPriceNum, DetailsPriceText, DetailsSide,
    DetailsSideInner, DetailsTimePast, DetailsTop,
    ExchangeIconImg,
    ExTOInfo, ExTOInfoNew,
    IconDetailsWrapperDel,
    IconDetailsWrapperFav,
    Info24Container,
    LeftCenterContainer,
    InfoRow,
    Link,
    MainMoreInfoBlock,
    MarketContainer,
    MarketIconImg,
    MoreInfoExchangeBlock, MoreInfoSide,
    Overlay, OverlayCustomScrollLine1, OverlayCustomScrollLine2,
    OverlayMarket,
    OverlayProfit,
    OverlayTimestamp,
    ProfitContainer, ProfitPercentContainerRight, ReturnBlock, ReturnHalo, RightCenterContainer, SelectedExchangeName,
    TODetailsWrapper, TOInfoBottom,
    TOInfoTop
} from "./TODetails.styled";
import {ReactComponent as Favorite} from "../../assets/icons/fav.svg"
import {ReactComponent as Trash} from "../../assets/icons/trash.svg"
import {ReactComponent as ArrowDownNew} from "../../assets/icons/arrow_down.svg"
import {ReactComponent as ArrowUp} from "../../assets/icons/arrow_up.svg"
import {useAppDispatch} from "../../redux/store";
import {useSelector} from "react-redux";
import {selectors} from "../../redux/selectors";
import {useLazyGetPrecisionsQuery} from "../../redux/rtkApi/toFlowApi";

const TODetails: React.FC<{
    selected_item: ITOHistory,
    isOpen: boolean,
    isActive: boolean,
    selectedPrecisions?: ISelectedPrecisions
    selectedIndex: number
}> = ({selected_item, isOpen, isActive, selectedPrecisions, selectedIndex }) => {
    const [triggerGetPrecision] = useLazyGetPrecisionsQuery()

    const best_volume = selected_item.first_ex_volume > selected_item.second_ex_volume
        ? (selected_item.second_ex_volume * selected_item.second_ex_price).toFixed( 2)
        : (selected_item.first_ex_volume * selected_item.first_ex_price).toFixed(2);
    const profit_percent = selected_item.pure_profit / Number(best_volume) * 100;
    let best_change = "N/A"
    if (selectedPrecisions && selectedPrecisions.firstExChange24 && selectedPrecisions.secondExChange24) {
        if(Math.abs(selectedPrecisions.firstExChange24) > Math.abs(selectedPrecisions.secondExChange24)) {
            best_change = selectedPrecisions.firstExChange24.toString()
        } else {
            best_change = selectedPrecisions.secondExChange24.toString()
        }
    } else if (selectedPrecisions &&  selectedPrecisions.firstExChange24) {
        best_change = selectedPrecisions.firstExChange24.toString()
    } else if (selectedPrecisions &&  selectedPrecisions.secondExChange24) {
        best_change = selectedPrecisions.secondExChange24.toString()
    }
    const volume24 = selectedPrecisions && selectedPrecisions.firstExVol24 && selectedPrecisions.secondExVol24
        ? (selectedPrecisions.firstExVol24 + selectedPrecisions.secondExVol24).toFixed(2)
        : selectedPrecisions && selectedPrecisions.firstExVol24
            ? selectedPrecisions.firstExVol24.toFixed(2)
            : selectedPrecisions && selectedPrecisions.secondExVol24
                ? selectedPrecisions.secondExVol24.toFixed(2) : undefined

    const tg = window.Telegram?.WebApp;
    const dispatch = useAppDispatch()
    const history = useSelector(selectors.selectCurrentToHistoryState)
    const [timeFromAction, setTimeFromAction] = useState<string>('')
    useEffect(() => {
        const interval = setInterval(() => {
            setTimeFromAction(normalizeTime(selected_item.timestamp) ?? '')
        }, 1000)

        return () => clearInterval(interval)
    }, [])

    const toggleUp = async () => {
        if (selectedIndex === 0) {
            const to = history[history.length - 1];
            dispatch(setSelectedItem(to))
            dispatch(setSelectedItemIndex(history.length - 1))
            let res = await triggerGetPrecision({first_ex: to.first_ex, second_ex: to.second_ex, first_market: to.market, second_market: to.market})
            if (res.data) {
                dispatch(setSelectedPrecisions({
                    firstExPrice: res.data.first_precision.pricePrecision,
                    firstExVolume: res.data.first_precision.volumePrecision,
                    secondExPrice: res.data.second_precision.pricePrecision,
                    secondExVolume: res.data.second_precision.volumePrecision,
                    firstExVol24: res.data.first_precision.volume24,
                    firstExChange24: res.data.first_precision.change24,
                    secondExVol24: res.data.second_precision.volume24,
                    secondExChange24: res.data.second_precision.change24,
                }))
            }
        } else {
            const to = history[selectedIndex - 1];
            dispatch(setSelectedItem(to))
            dispatch(setSelectedItemIndex(selectedIndex - 1))
            const res = await triggerGetPrecision({first_ex: to.first_ex, second_ex: to.second_ex, first_market: to.market, second_market: to.market})
            if (res.data) {
                dispatch(setSelectedPrecisions({
                    firstExPrice: res.data.first_precision.pricePrecision,
                    firstExVolume: res.data.first_precision.volumePrecision,
                    secondExPrice: res.data.second_precision.pricePrecision,
                    secondExVolume: res.data.second_precision.volumePrecision,
                    firstExVol24: res.data.first_precision.volume24,
                    firstExChange24: res.data.first_precision.change24,
                    secondExVol24: res.data.second_precision.volume24,
                    secondExChange24: res.data.second_precision.change24,
                }))
            }
        }
    }
    const toggleDown = async () => {
        if (selectedIndex === history.length - 1) {
            const to = history[0];
            dispatch(setSelectedItem(to))
            dispatch(setSelectedItemIndex(0))
            const res = await triggerGetPrecision({first_ex: to.first_ex, second_ex: to.second_ex, first_market: to.market, second_market: to.market})
            if (res.data) {
                dispatch(setSelectedPrecisions({
                    firstExPrice: res.data.first_precision.pricePrecision,
                    firstExVolume: res.data.first_precision.volumePrecision,
                    secondExPrice: res.data.second_precision.pricePrecision,
                    secondExVolume: res.data.second_precision.volumePrecision,
                    firstExVol24: res.data.first_precision.volume24,
                    firstExChange24: res.data.first_precision.change24,
                    secondExVol24: res.data.second_precision.volume24,
                    secondExChange24: res.data.second_precision.change24,
                }))
            }
        } else {
            const to = history[selectedIndex + 1];
            dispatch(setSelectedItem(to))
            dispatch(setSelectedItemIndex(selectedIndex + 1))
            const res = await triggerGetPrecision({first_ex: to.first_ex, second_ex: to.second_ex, first_market: to.market, second_market: to.market})
            if (res.data) {
                dispatch(setSelectedPrecisions({
                    firstExPrice: res.data.first_precision.pricePrecision,
                    firstExVolume: res.data.first_precision.volumePrecision,
                    secondExPrice: res.data.second_precision.pricePrecision,
                    secondExVolume: res.data.second_precision.volumePrecision,
                    firstExVol24: res.data.first_precision.volume24,
                    firstExChange24: res.data.first_precision.change24,
                    secondExVol24: res.data.second_precision.volume24,
                    secondExChange24: res.data.second_precision.change24,
                }))
            }        }
    }
    const base = selected_item.market.split("/")[0]
    const quote = selected_item.market.split("/")[1]

    const nextMarketName = selectedIndex === 0
        ? history[history.length - 1]?.market.split("/")[0]
        : history[selectedIndex - 1]?.market.split("/")[0]
    const prevMarketName = selectedIndex === history.length - 1
        ? history[0]?.market.split("/")[0]
        : history[selectedIndex + 1]?.market.split("/")[0]

    const favoritesMarkets = useSelector(selectors.selectFavorites)
    const deletedMarkets = useSelector(selectors.selectDeleted)

    const findFavDel = (item: IFavoriteDeleteItem): boolean => {
       return item.market === selected_item.market && item.first_ex === selected_item.first_ex && item.second_ex === selected_item.second_ex
    }
    const filterFavDel = (item: IFavoriteDeleteItem): boolean => {
       return item.market !== selected_item.market || item.first_ex !== selected_item.first_ex || item.second_ex !== selected_item.second_ex
    }

    const marketIsFavorite = Boolean(favoritesMarkets.find((item) => findFavDel(item)))
    const marketIsDeleted = Boolean(deletedMarkets.find((item) => findFavDel(item)))

    const addToFavorite = (item: ITOHistory): void => {
        localStorage.setItem(FAVORITES_MARKETS_KEY, JSON.stringify([...favoritesMarkets, {market: item.market, first_ex: item.first_ex, second_ex: item.second_ex}]))
        dispatch(setFavorites([...favoritesMarkets, {market: item.market, first_ex: item.first_ex, second_ex: item.second_ex}]))
    }
    const removeFromFavorite = (item: ITOHistory): void => {
        localStorage.setItem(FAVORITES_MARKETS_KEY, JSON.stringify([...favoritesMarkets.filter((fav) => findFavDel(item))]))
        dispatch(setFavorites([...favoritesMarkets.filter((fav) => findFavDel(item))]))
    }
    const addToDeleted = (item: ITOHistory): void => {
        localStorage.setItem(DELETED_MARKETS_KEY, JSON.stringify([...deletedMarkets, {market: item.market, first_ex: item.first_ex, second_ex: item.second_ex}]))
        dispatch(setDeleted([...deletedMarkets, {market: item.market, first_ex: item.first_ex, second_ex: item.second_ex}]))
    }
    const removeFromDeleted = (item: ITOHistory): void => {
        localStorage.setItem(DELETED_MARKETS_KEY, JSON.stringify([...deletedMarkets.filter((del) => filterFavDel(item))]))
        dispatch(setDeleted([...deletedMarkets.filter((del) => filterFavDel(del))]))
    }
    const toggleFavorite = (includes: boolean, item: ITOHistory)=> {
        if (includes) {
            removeFromFavorite(item)
        } else {
            addToFavorite(item)
        }
    }
    const toggleDeleted = (includes: boolean, item: ITOHistory)=> {
        if (includes) {
            removeFromDeleted(item)
        } else {
            addToDeleted(item)
        }
    }
    return (
        <TODetailsWrapper>
            <DetailsTop>
                <DetailsPrice>
                    <DetailsPriceContainer>
                        <DetailsPriceNum>
                            <DetailsPriceText>PRICE</DetailsPriceText>
                            <span>
                                {selected_item.first_ex_price.toFixed(selectedPrecisions?.firstExPrice ? selectedPrecisions?.firstExPrice : 2)} $
                            </span>
                        </DetailsPriceNum>
                    </DetailsPriceContainer>
                </DetailsPrice>
                <DetailsSide>
                    <DetailsSideInner
                        isSell={selected_item.first_ex_side.toUpperCase() === 'SELL'}
                        onClick={() => tg?.openLink(ExchangesRefLinksObj[selected_item.first_ex] as string)}
                    >
                        {selected_item.first_ex_side.toUpperCase()}
                    </DetailsSideInner>
                </DetailsSide>
                <DetailsExchange>
                        <DetailsExchangeName>
                            {selected_item.first_ex.toUpperCase()}
                        </DetailsExchangeName>
                        <DetailsExchangeIcon
                            $src={imageLinkToEx(selected_item.first_ex)}
                            // onClick={() => openInNewTab(getExchangeSpotLink(selected_item.first_ex, selected_item.market) as string)}
                        />
                </DetailsExchange>
            </DetailsTop>
            <DetailsContainer>
                <DetailsCenter>
                    <LeftCenterContainer isFavorite={marketIsFavorite}>
                        <IconDetailsWrapperFav
                            isFavorite={marketIsFavorite}
                            onClick={() => toggleFavorite(marketIsFavorite, selected_item)}>
                            <Favorite/>
                        </IconDetailsWrapperFav>
                        <MarketContainer>
                            <div>{base}</div>
                            <span>
                                /{quote}
                            </span>
                        </MarketContainer>
                        <Info24Container>
                            <span>CHANGE 24H</span>
                            <div>
                                {best_change}%
                            </div>
                        </Info24Container>
                        <Info24Container>
                            <span>VOLUME 24H</span>
                            <div>
                                {volume24 ? numToShortText(Number(volume24)) : 'N/A'}
                            </div>
                        </Info24Container>
                    </LeftCenterContainer>
                    <CenterCenterContainer>
                        <SelectedExchangeName>{nextMarketName}</SelectedExchangeName>
                        <ArrowUp onClick={toggleUp}/>
                        <DetailsMarketWrapper>
                            <DetailsMarketIcon $src={imageLink(base)}/>
                        </DetailsMarketWrapper>
                        <ArrowDownNew onClick={toggleDown}/>
                        <SelectedExchangeName>{prevMarketName}</SelectedExchangeName>
                    </CenterCenterContainer>
                    <RightCenterContainer isDeleted={marketIsDeleted}>
                        <IconDetailsWrapperDel
                            isDeleted={marketIsDeleted}
                            onClick={() => toggleDeleted(marketIsDeleted, selected_item)}>
                            <Trash/>
                        </IconDetailsWrapperDel>
                        <ProfitPercentContainerRight>
                            <span>PROFIT %</span>
                            <div>
                                {profit_percent > 0 ? '+' : '-' }{profit_percent.toFixed(2)}%
                            </div>
                        </ProfitPercentContainerRight>
                        <ProfitContainer>
                            <span>PROFIT</span>
                            <div>
                                {selected_item.pure_profit > 0 ? '+' : '-' }{selected_item.pure_profit.toFixed(2)}$
                            </div>
                        </ProfitContainer>
                        <ProfitPercentContainerRight>
                            <span>MIN VOLUME</span>
                            <div>
                                {best_volume}$
                            </div>
                        </ProfitPercentContainerRight>
                    </RightCenterContainer>
                </DetailsCenter>
                <DetailsTimePast>
                    TIME FROM ACTION: <span>{timeFromAction}</span>
                </DetailsTimePast>
            </DetailsContainer>
            <DetailsBottom>
                <DetailsPrice>
                    <DetailsPriceContainer>
                        <DetailsPriceNum>
                            <DetailsPriceText>PRICE</DetailsPriceText>
                            <span>
                                {selected_item.second_ex_price.toFixed(selectedPrecisions?.secondExPrice ? selectedPrecisions?.secondExPrice : 2)} $
                            </span>
                        </DetailsPriceNum>
                    </DetailsPriceContainer>
                </DetailsPrice>
                <DetailsSide>
                    <DetailsSideInner
                        isSell={selected_item.second_ex_side.toUpperCase() === 'SELL'}
                        onClick={() => tg?.openLink(ExchangesRefLinksObj[selected_item.second_ex] as string)}
                    >
                        {selected_item.second_ex_side.toUpperCase()}
                    </DetailsSideInner>
                </DetailsSide>
                <DetailsExchange>
                        <DetailsExchangeName>
                                {selected_item.second_ex.toUpperCase()}
                        </DetailsExchangeName>
                        <DetailsExchangeIcon
                            $src={imageLinkToEx(selected_item.second_ex)}
                            // onClick={() => openInNewTab(getExchangeSpotLink(selected_item.second_ex, selected_item.market) as string)}
                        >
                        </DetailsExchangeIcon>
                </DetailsExchange>
            </DetailsBottom>
        </TODetailsWrapper>
    );
}
export default TODetails